import ServiceWorkerMessage from './interfaces/ServiceWorkerMessage';
import { trace } from 'owa-trace';

export default function serviceWorkerErrorEvent(message: ServiceWorkerMessage): void {
    if (message.error != null) {
        trace.error({
            message: '[SW Client] ServiceWorker Unhandled Exception',
            error: message.error,
        });
    }
}
